"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = require("./styled-components");
var _overrides = require("../helpers/overrides");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
class AutosizeInput extends React.Component {
  constructor(...args) {
    super(...args);
    // @ts-ignore
    _defineProperty(this, "mounted", void 0);
    _defineProperty(this, "sizer", void 0);
    _defineProperty(this, "state", {
      inputWidth: 5
    });
    _defineProperty(this, "sizerRef", el => {
      this.sizer = el;
    });
  }
  componentDidMount() {
    this.mounted = true;
    this.updateInputWidth();
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    this.updateInputWidth();
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  updateInputWidth() {
    if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
      return;
    }
    const newInputWidth = this.sizer.scrollWidth + 2;
    if (newInputWidth !== this.state.inputWidth && this.sizer.scrollWidth !== this.state.inputWidth) {
      this.setState({
        inputWidth: newInputWidth
      });
    }
  }
  render() {
    const {
      overrides = {},
      inputRef,
      ...restProps
    } = this.props;
    const [Input, inputProps] = (0, _overrides.getOverrides)(overrides.Input, _styledComponents.StyledInput);
    const sizerValue = [this.props.defaultValue, this.props.value, ''].reduce((previousValue, currentValue) => {
      if (previousValue !== null && previousValue !== undefined) {
        return previousValue;
      }
      return currentValue;
    });
    const componentInputProps = {
      ...restProps,
      $width: `${this.state.inputWidth}px`
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, _extends({}, componentInputProps, {
      ref: inputRef
    }, inputProps)), /*#__PURE__*/React.createElement(_styledComponents.StyledInputSizer, {
      $size: this.props.$size,
      ref: this.sizerRef,
      $style: inputProps.$style ? inputProps.$style : null
    }, sizerValue));
  }
}
exports.default = AutosizeInput;
_defineProperty(AutosizeInput, "defaultProps", {
  inputRef: /*#__PURE__*/React.createRef(),
  value: '',
  overrides: {}
});